import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const FormRuler = () => {
  return (
    <hr
      css={css({
        marginBottom: theme.spacing(2),
        borderColor: theme.colors.neutral[20],
        borderWidth: '0 0 1px 0',
      })}
    />
  );
};
